import { AxiosHeaders, AxiosResponse } from 'axios';

import { FETCH_TOKEN_ENDPOINT } from '../../constants/token-endpoints.const';
import { WebStoreApiTokensRequestBody } from '../../models';
import { WebStoreTokenResponse } from '../../models/webstore-token-response';
import { getTokenFromHeaders } from '../../utilities/get-token-from-headers';
import { webStoreHttp } from '../web-store-api';

export const fetchAuthToken = async (
  body: WebStoreApiTokensRequestBody,
  headers: AxiosHeaders
): Promise<WebStoreTokenResponse> => {
  const response = await webStoreHttp.post<
    WebStoreApiTokensRequestBody,
    AxiosResponse<WebStoreTokenResponse>
  >(`/${FETCH_TOKEN_ENDPOINT}`, body, { headers });
  const result = response.data;
  result.token = getTokenFromHeaders(response.headers);

  return result;
};
